<template>
  <div :class="progressWrapperClass">
    <slot name="before"></slot>
    <div :class="progressClass"
         role="progressbar"
         :style="progressStyle"
         :aria-valuenow="currentPercentage"
         :aria-valuemin="min"
         :aria-valuemax="max"
    >
      <slot></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'AdvProgressBar',
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    current: {
      type: [String, Number],
      default: 0
    },
    progressWrapperClass: {
      type: String,
      default: 'progress'
    },
    progressBaseClass: {
      type: String,
      default: 'progress-bar'
    },
    progressFillClass: {
      type: String,
      default: 'bg-gradient-success'
    },
    progressClassModifierMinimum: {
      type: String,
      default: 'minimum'
    },
    progressClassModifierMaximum: {
      type: String,
      default: 'maximum'
    }
  },
  computed: {
    progressClass: function () {
      const progressModifierClass = (this.isMax) ? this.progressClassModifierMaximum
        : (this.isMin) ? this.progressClassModifierMinimum : ''
      return [this.progressBaseClass, this.progressFillClass, progressModifierClass].join(' ').trim()
    },
    progressStyle: function () {
      return 'width: ' + this.currentPercentage + '%'
    },
    currentPercentage: function () {
      if (this.current < this.min) {
        return 0
      }
      if (this.current > this.max) {
        return 100
      }
      return (this.current - this.min) * 100 / (this.max - this.min)
    },
    isMax: function () {
      return this.current >= this.max
    },
    isMin: function () {
      return this.current <= this.min
    }
  }
}
</script>

<style lang="scss" scoped>
$prime1:#38f490;
$prime2:#F6F0E9;
$prime3:#3C3C3B;

.minicart-progress {
  @keyframes minicart-progress-anim {
    0% { background-color: rgb(255, 255, 255); }
    100% { background-color: rgba(245, 245, 245, 0.4); }
  }
  @-webkit-keyframes minicart-progress-anim {
    0% { background-color: rgb(255, 255, 255); }
    100% { background-color: rgba(245, 245, 245, 0.4); }
  }
  &-wrapper {
    height: 10px;
    position: relative;
    background: white;
    border: 1px solid #EF4056;
    margin-top: 15px;
    border-radius: 10px;
  }
  &-base{
    display: block;
    height: 100%;
    transition: all .5s ease-in-out;
  }
  &-fill {
    background-color: #FDE6E8;
    border: 1px solid #EF4056;
    border-radius: 10px;
    &.maximum {
      animation: none;
      -webkit-animation: none;
    }
  }
  &-logo {
    width: 20px;
    height: 26px;
    position: absolute;
    right: -5px;
    top: -23px;
    background: url(../../img/points_icon.png) no-repeat;
    background-size: 20px;
    &-wrapper {
      display: block;
      margin-top: 16px;
      margin-right: 0;
      margin-left: auto;
      position: relative;
    }
  }
}
</style>
